import { Component, Output, HostListener, ElementRef, EventEmitter, ChangeDetectorRef, ApplicationRef } from '@angular/core';
import {
  DataLoaderService, ImageLoaderService, VehicleInfoService,
  PriceCalculationService, ProgressBarService, CommonDataService
} from '../index';
import { Subscription } from 'rxjs/Subscription';
import { TranslateService } from '@ngx-translate/core';
import { Utils } from '../../shared/utils';
@Component({
  selector: 'banner-area',
  templateUrl: './banner-area.template.html',
  styleUrls: ['./banner-area.component.css']
})

export class BannerAreaComponent {

  private baumuster; currency; pricingDate; vehCodes: string; productionDateGcc;productionDateAmend;requestedproductionDate;configurationDate
  vehicleDescription; vehClass: string; vehSubClass: string;
  public icon: string = "gray";
  public descVisibility: boolean = true;
  public priceVisibility: boolean = false;
  public checkVisibility: boolean = false;
  public closeOnclick: boolean = true;
  private imageURL: string;
  private imageName: string;
  private basePrice: number;
  public classNames = ["MB+ACLASS", "MB+BCLASS", "MB+CCLASS", "MB+ECLASS", "MB+GCLASS", "MB+SCLASS", "MB+MCLASS"];
  vehicleInformation: { hookURL: string; urlFlag: string; language: string; configurationDate: string; orderingMarket: string; pricingDate: string; salesLevel: string; taxDate: string; materialType: string; plant: string; baumuster: string; internalVehicleId: string; savedConfig: string; productionDate: string; vehicleDescription: string; vehicleClass: string; preSeriesModeFlag: string; driveType: string; materialGroupExt: string; requestedProductionDate: string; authToken: string; };
  // progress bar Variables
  private redProgressBar: boolean = false;
  private yellowProgressBar: boolean = false;
  private greenProgressBar: boolean = false;
  private subscription: Subscription;
  private typeOfDrive: string;
  private extMaterialGrp: string;

  constructor(private dataLoaderService: DataLoaderService, private priceCalculationService: PriceCalculationService,
    private imageLoaderService: ImageLoaderService, private progressBarService: ProgressBarService,
    private commonDataService: CommonDataService, private translate: TranslateService,
    private cdr: ChangeDetectorRef, private app: ApplicationRef, private vehicleInfo: VehicleInfoService, private vehicleInfoService: VehicleInfoService) {
      this.vehicleInformation = this.vehicleInfoService.extractData();
    }

  ngOnInit() {
    if (this.dataLoaderService.vehicleInfo.urlFlag === '0') {
      this.redProgressBar = true;
      this.greenProgressBar = false;
      this.yellowProgressBar = false;
      this.cdr.detectChanges();
    }
    
    // this.progressBarService.progressBarValidation();
    
    //Japan Change - Add ¥ currency symbol instead of JPY
     if(this.dataLoaderService.data.currencyType == "JPY"){
      this.dataLoaderService.data.currencyType = "¥";
    }
    this.baumuster = this.dataLoaderService.vehicleInfo.baumuster;
    this.currency = this.dataLoaderService.data.currencyType;
     this.basePrice = this.dataLoaderService.data.vehInfo[0].priceBpmBm;
    this.cdr.detectChanges();
    this.typeOfDrive = this.dataLoaderService.vehicleInfo.driveType;
    this.extMaterialGrp = this.dataLoaderService.vehicleInfo.materialGroupExt;
    if (this.dataLoaderService.vehicleInfo.baumuster != "") {
      if (this.dataLoaderService.vehicleInfo.baumuster.substring(0, 3) === "463")
        this.vehClass = this.dataLoaderService.vehicleInfo.baumuster.substring(0, 3);
      else
        this.vehClass = this.dataLoaderService.vehicleInfo.baumuster.substring(0, 4);
    }

    this.vehicleDescription = this.vehicleInformation.vehicleDescription.split('+').join(' ');
    this.pricingDate = this.dataLoaderService.vehicleInfo.pricingDate.substring(0, 4) + '/' + this.dataLoaderService.vehicleInfo.pricingDate.substring(4, 6) + '/' + this.dataLoaderService.vehicleInfo.pricingDate.substring(6);
    if(this.dataLoaderService.vehicleInfo.urlFlag == '0'){
    this.productionDateGcc = this.dataLoaderService.vehicleInfo.productionDate.substring(0, 4) + '/' + this.dataLoaderService.vehicleInfo.productionDate.substring(4, 6) + '/' + this.dataLoaderService.vehicleInfo.productionDate.substring(6);
    }else{
    var stringtojson =  JSON.parse(this.dataLoaderService.vehicleInfo.savedConfig);
    var newjson = stringtojson["productionDate"];
    this.productionDateAmend = newjson.substring(0, 4) + '/' + newjson.substring(4, 6) + '/' + newjson.substring(6);}
    this.requestedproductionDate = this.dataLoaderService.vehicleInfo.requestedProductionDate.substring(0, 4) + '/'+ this.dataLoaderService.vehicleInfo.requestedProductionDate.substring(4, 6) + '/' + this.dataLoaderService.vehicleInfo.requestedProductionDate.substring(6);;
    this.configurationDate = this.dataLoaderService.vehicleInfo.productionDate.substring(0, 4) + '/' + this.dataLoaderService.vehicleInfo.productionDate.substring(4, 6) + '/' + this.dataLoaderService.vehicleInfo.productionDate.substring(6);
    //To retrieve the Image on the banner area
    
    let imageData = this.imageLoaderService.getImageData();
    imageData.subscribe(
      imageResponse => {
        //TODO Suchi
        if (!(this.vehicleInfo.urlDataFromLink.orderingMarket === '901' || this.vehicleInfo.urlDataFromLink.orderingMarket === '919' 
        || this.isMarketCA_N() || this.isMarketCA_T() || this.isMarketMX() || this.isMarketEG())){
        if (this.dataLoaderService.vehicleInfo.baumuster === "") {
          this.imageURL = imageResponse.vehicleClass[0].default_car;
         }else {
          for (let i = 0; i < imageResponse.vehicleClass.length; i++) {
            if (this.vehClass === imageResponse.vehicleClass[i].code) {
              this.imageName = imageResponse.vehicleClass[i].NAME;
              this.imageURL = imageResponse.vehicleClass[i].VALUE;              
            }
          }
        }
      }
      else {
        if(this.vehicleInfo.urlDataFromLink.orderingMarket === '901' || this.vehicleInfo.urlDataFromLink.orderingMarket === '919'){
          this.imageURL = "./assets/img/classes/MB_logo.png";
          this.imageName = this.dataLoaderService.vehicleInfo.vehicleClass;
        }
        if(this.isMarketCA_T() || this.isMarketCA_N() || this.isMarketMX()){
          this.imageURL = "./assets/img/classes/CA_Background.jpg";
          this.imageName = this.vehicleDescription;
        }
        if(this.isMarketEG()){
            for (let i = 0; i < imageResponse.vehicleClass.length; i++) {
            if (this.vehClass === imageResponse.vehicleClass[i].code) {
              this.imageURL = imageResponse.vehicleClass[i].VALUE;
              break;      
            }else{
              this.imageURL = "./assets/img/classes/default_car.png";
            }       
          }
          this.imageName = this.vehicleDescription;    
        }
        
      }

        //Setting default Image URL path and Name
        if ((this.imageName === undefined || this.imageName === " ") &&
          (this.imageURL === undefined) || this.imageURL === " ") {
            //TODO Suchi
        if (!(this.vehicleInfo.urlDataFromLink.orderingMarket === '901' || this.vehicleInfo.urlDataFromLink.orderingMarket === '919')){
          this.imageURL = "./assets/img/classes/default_car.png";
          this.imageName = " ";
          }
          else {
              this.imageURL = "./assets/img/classes/MB_logo.png";
              this.imageName = this.dataLoaderService.vehicleInfo.vehicleClass;    
          }
        }
        this.commonDataService.sendSelectedClass(this.imageURL);
        this.commonDataService.sendSelectedClassName(this.imageName);
      },
    );
   
    

    // To display the Progress services
    // setTimeout(() =>
    this.subscription = this.progressBarService.notifyObservableRed$.subscribe((res) => {
      this.redProgressBar = true;
      this.greenProgressBar = false;
      this.yellowProgressBar = false;
      this.cdr.detectChanges();
      //   })
    });
    //setTimeout(() =>
    this.subscription = this.progressBarService.notifyObservableYellow$.subscribe((res) => {
      this.redProgressBar = false;
      this.greenProgressBar = false;
      this.yellowProgressBar = true;
      this.cdr.detectChanges();
      // })
    });
    // setTimeout(() =>
    this.subscription = this.progressBarService.notifyObservableGreen$.subscribe((res) => {
      this.redProgressBar = false;
      this.greenProgressBar = true;
      this.yellowProgressBar = false;
      this.cdr.detectChanges();
      // })
    });
  }
  /**
  * To display and hide the Model Information
  * @param none
  * @returns none
  */
  openDescriptionOnClick() {
    this.closeOnclick = false;
    if (this.icon == "gray") {
      this.icon = "blue";
    } else {
      this.icon = "gray";
      this.descVisibility = true;
      this.priceVisibility = false;
    }


    if (!this.checkVisibility) {
      this.descVisibility = false;
      this.priceVisibility = true;
      this.checkVisibility = true;
    }
  }
  closeDescriptionOnHover() {
    if (this.closeOnclick) {
      this.descVisibility = true;
      this.priceVisibility = false;
    }
  }
  openDescriptionOnHover() {
    this.closeOnclick = true;
    this.descVisibility = false;
    this.priceVisibility = true;
  }
  /**
  * To display the Expert Mode
  * @param none
  * @returns none
  */
  openExpertMode() {
    //this.cdr.detectChanges();
    this.dataLoaderService.flagDictionary.modeFlag = 'expert';
    this.dataLoaderService.flagDictionary.expertFlag = false;
    this.dataLoaderService.flagDictionary.testFlag = false;
    this.dataLoaderService.flagDictionary.migrationFlag = false;
  }

  isMarketCA_N(){
		return Utils.isCountryCA_N(this.vehicleInfo.urlDataFromLink.orderingMarket);
	}
	
	isMarketCA_T(){
		return Utils.isCountryCA_T(this.vehicleInfo.urlDataFromLink.orderingMarket);
  }
  isMarketMX(){
		return Utils.isCountryMX(this.vehicleInfo.urlDataFromLink.orderingMarket);
	}
  isMarketEG(){
    return Utils.isCountryEG(this.vehicleInfo.urlDataFromLink.orderingMarket);
  }

}



// WEBPACK FOOTER //
// ./src/app/components/banner-area/banner-area.component.ts